module.exports = __webpack_public_path__ + "static/media/135.ea2ff0fe.png";